import { IRadicadoEntradaExtended } from "../../classes/radicado-entrada-extended";
import { IDocumento } from "../../ioip/sdk/base";
import { IContextualMenuItem } from "@fluentui/react";

export interface IMyRequestsComponentState {
    items: IRadicadoEntradaExtended[];
    errors: { [ key: string ]: string };
    Identificacion: string;
    IdTipoIdentificacion: string;
    IdRadicadoEntradaSelected: number;
    data: {
        extensionesPermitiras: string;
    },
    commandBar: IContextualMenuItem[];
}

export function defaultMyRequestsComponentState(): IMyRequestsComponentState {
    return {
        items: [],
        Identificacion: '',
        IdTipoIdentificacion: '',
        errors: {},
        IdRadicadoEntradaSelected: 0,
        data: {
            extensionesPermitiras: 'pdf docx txt xls'
        },
        commandBar: []
    };
}